export default __webpack_public_path__ + "static/media/icon-flex-report.2c269cc6.svg";